import {Injectable} from "@angular/core";
import {
  AbstractFilterCode,
  Code,
  CodeByRegionTypeLabelLanguageFilter,
  UnionFilter
} from "@icure/api";
import {ApiService} from "./api.service";
import {GROUP_ID_TEMPLATE} from "./tools.service";
import {UtilsService} from "./utils.service";
import {
  COMPLETED,
  ERROR, WAITING
} from "../../app/private/database/database-group-info/dialogs/code-importation-dialog/code-importation-dialog.component";

@Injectable({
  providedIn: 'root',
})

export class CodeService {
  constructor(
    private api: ApiService,
    private utils: UtilsService
  ) {
  }

  public async getCodesByIds(groupId: string, codeIds?: string[]): Promise<Code[]> {
    return await this.api.codeApi.getCodesInGroup(groupId, codeIds ?? []);
  }

  public async getCodesIds(groupId: string, filter: AbstractFilterCode): Promise<string[]> {
    return await this.api.codeApi.matchCodesByInGroup(groupId, filter)
  }

  public async injectCodeIntoDb(targetGroup: string, codeType: string): Promise<{
    injectedCodes: number;
    updatedCodes: number;
    status: string;
  }> {
    const filter: AbstractFilterCode = new AbstractFilterCode(new UnionFilter([new CodeByRegionTypeLabelLanguageFilter({
        type: codeType,
        language: "fr"
      }), new CodeByRegionTypeLabelLanguageFilter({
        type: codeType,
        language: "nl"
      }), new CodeByRegionTypeLabelLanguageFilter({
        type: codeType,
        language: "en"
      })])
    )
    const idsFromTemplate: string[] = await this.getCodesIds(GROUP_ID_TEMPLATE, filter) ?? [];
    const existingIdsInTargetDb: string[] = await this.getCodesIds(targetGroup, filter) ?? [];
    let injectedCodes: number = 0;
    let updatedCodes: number = 0;
    if (idsFromTemplate?.length > 0) {
      for (const chunckedIds of this.utils.chunkArray(idsFromTemplate, 100)) {
        try {
          const codesFromTemplate: Code[] = await this.getCodesByIds(GROUP_ID_TEMPLATE, chunckedIds);
          const codesToInject: Code[] = codesFromTemplate.filter(c => !existingIdsInTargetDb.includes(c.id!));
          const codesToUpdate: Code[] = codesFromTemplate.filter(c => existingIdsInTargetDb.includes(c.id!));
          injectedCodes += codesToInject?.length ?? 0;
          updatedCodes += codesToUpdate?.length ?? 0;
          if (codesToInject?.length) {
            codesToInject.map(code => delete code.rev);
            await this.api.codeApi.createCodesInGroup(targetGroup, codesToInject);
          }
          if (codesToUpdate?.length) {
            const codesFromTarget: Code[] = await this.getCodesByIds(targetGroup, codesToUpdate.map(c => c.id!!));
            const templateByIds: Record<string, Code> = Object.fromEntries(codesToUpdate.map(c => [c.id, c]));
            const mergedCodes: Code[] = codesFromTarget.map(targetCode => {
              const templateCode = templateByIds[targetCode.id!];
              if (!templateCode) return targetCode;
              const {rev, type, id, version, ...templateData} = templateCode;
              return {...targetCode, ...templateData};
            });
            await this.api.codeApi.modifyCodesInGroup(targetGroup, mergedCodes);
          }
        } catch (e) {
          return {injectedCodes: injectedCodes, updatedCodes: updatedCodes, status: ERROR};
        }
      }
      return {injectedCodes: injectedCodes, updatedCodes: updatedCodes, status: COMPLETED};
    }
    return {injectedCodes: 0, updatedCodes: 0, status: WAITING};
  }

}
